export const API_URL = "https://api.shrtco.de/v2/shorten";
export const TIMEOUT_SEC = 10;
export const TIMEOUT_SEC_BTN = 5;
export const TIMEOUT_SEC_STORAGE = 3 * 60 * 60;